import React, { useState, useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  List,
  PostAddOutlined,
  RequestPageOutlined,
  ArrowRightAltOutlined,
  CategoryOutlined,
} from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { Grid, Box, CardContent } from "@mui/material";

import ReportClientList from "views/dialog/ReportClientList";
import ReportTransactionsOperatorList from "views/dialog/ReportTransactionsOperatorList";
import ReportTransactionsProductsList from "views/dialog/ReportTransactionsProductsList";

import {
  cardBodyStyle,
  ButtonTableGrid3,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ReportsPanels() {
  const classes = useStyles();

  const [openClientList, setopenClientList] = useState(false);
  const [openTransactionOperatorList, setOpenTransactionOperatorList] =
    useState(false);
  const [openTransactionProductsList, setOpenTransactionProductsList] =
    useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleCloseClientList = () => {
    setopenClientList(false);
  };

  const handleCloseTransactionOperatorLists = () => {
    setOpenTransactionOperatorList(false);
  };

  const handleCloseTransactionProductsLists = () => {
    setOpenTransactionProductsList(false);
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <List className={classes.iconFilter} /> Reportes
        </div>
        <Card style={{ padding: "10px 20px" }}>
          <CardBody>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Card
                  style={{
                    background: "papayawhip",
                  }}
                >
                  <CardContent>
                    {" "}
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 16 }}
                    >
                      <PostAddOutlined
                        style={{ fontSize: 26, marginRight: 10 }}
                      />
                      Listado de clientes
                    </div>
                  </CardContent>
                  <Box
                    style={{
                      textAlign: "right",
                      padding: "10px 25px",
                    }}
                  >
                    <ButtonTableGrid3
                      style={{
                        margin: "8px 0 2px 0",
                        padding: "4px 15px",
                        fontSize: 12,
                      }}
                      onClick={() => setopenClientList(true)}
                    >
                      Generar <ArrowRightAltOutlined />
                    </ButtonTableGrid3>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card
                  style={{
                    background: "papayawhip",
                  }}
                >
                  <CardContent>
                    {" "}
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 16 }}
                    >
                      <RequestPageOutlined
                        style={{ fontSize: 26, marginRight: 10 }}
                      />
                      Transacciones por gestores
                    </div>
                  </CardContent>
                  <Box
                    style={{
                      textAlign: "right",
                      padding: "10px 25px",
                    }}
                  >
                    <ButtonTableGrid3
                      style={{
                        margin: "8px 0 2px 0",
                        padding: "4px 15px",
                        fontSize: 12,
                      }}
                      onClick={() => setOpenTransactionOperatorList(true)}
                    >
                      Generar <ArrowRightAltOutlined />
                    </ButtonTableGrid3>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Card
                  style={{
                    background: "papayawhip",
                  }}
                >
                  <CardContent>
                    {" "}
                    <div
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 16 }}
                    >
                      <CategoryOutlined
                        style={{ fontSize: 26, marginRight: 10 }}
                      />
                      Transacciones productos
                    </div>
                  </CardContent>
                  <Box
                    style={{
                      textAlign: "right",
                      padding: "10px 25px",
                    }}
                  >
                    <ButtonTableGrid3
                      style={{
                        margin: "8px 0 2px 0",
                        padding: "4px 15px",
                        fontSize: 12,
                      }}
                      onClick={() => setOpenTransactionProductsList(true)}
                    >
                      Generar <ArrowRightAltOutlined />
                    </ButtonTableGrid3>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </GridItem>
      {openClientList && (
        <ReportClientList open={openClientList} exit={handleCloseClientList} />
      )}
      {openTransactionOperatorList && (
        <ReportTransactionsOperatorList
          open={openTransactionOperatorList}
          exit={handleCloseTransactionOperatorLists}
        />
      )}
      {openTransactionProductsList && (
        <ReportTransactionsProductsList
          open={openTransactionProductsList}
          exit={handleCloseTransactionProductsLists}
        />
      )}
    </GridContainer>
  );
}
